import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { inject, observer } from "mobx-react";
import Board from "../../../components/organisms/board";
import menu from "../../../data/menu";
import LogInfo from "../../../components/atoms/LogInfo";
import ToastMessage from "../../../components/molecules/ToastMessage";

const MainTemplate = inject("commonStore")(
  observer((props) => {
    const [menuRadio, setMenuRadio] = useState(
      localStorage["menu"] === "0" ? { 0: true } : localStorage["menu"] === "1" ? { 1: true } : localStorage["menu"] === "2" ? { 2: true } : { 3: true }
    ); // 옵션 고르기 state
    const [lengths, setLengths] = useState([]); // 칼럼별 길이 state
    useEffect(() => {
      setOption([...option]);
      option[localStorage["menu"]].color = "#3B86FF"; // 선택한 항목 디자인 변경
      option[localStorage["menu"]].border = "#3B86FF";
      props.commonStore
        .getAllList() // 칼럼 전체 가져오기
        .then((v) => {
          setLengths({
            0: v.length,
            1: v.filter((d) => d.category === "기사").length,
            2: v.filter((d) => d.category === "칼럼").length,
            3: v.filter((d) => d.writer_id === parseInt(localStorage.getItem("writer_id"))).length,
          });
        });
      props.commonStore.setTodo(3, 3); //할 일 목록 초기화
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [option, setOption] = useState(menu); // 칼럼 분류 리스트 state
    const handleRadio = (e) => {
      //radio 변경할 때
      let obj = {}; // 대체 값 설정 : handleRadio를 실행 할 때 가져오는 값이 늦어서 따로 설정
      obj[e.target.value] = e.target.checked; //예) value=0, checked=true => {0: true}
      setMenuRadio(obj);
      setOption([...option]);
      for (let i in option) {
        if (obj[i] === true) {
          option[i].color = "#3B86FF"; // 선택한 항목 디자인 변경
          option[i].border = "#3B86FF";
        } else {
          option[i].color = "#A1A1B1"; // 선택 안한 항목 디자인 변경
          option[i].border = "#E5E5E5";
        }
      }

      if (obj[e.target.value] === true) {
        // 선택 값에 따라 칼럼 필터링 바꾸기
        props.commonStore.setMode(parseInt(e.target.value));
      }

      //선택 시 페이지 변환시키기
      if (props.commonStore.mode === 0) {
        props.commonStore.getAllPage(1).then((v) => {
          props.commonStore.setPage(v);
        });
      }

      localStorage.setItem("menu", e.target.value); // 메뉴 위치 기억하기

      if (props.commonStore.mode === 1) {
        props.commonStore.getPage("기사", 1).then((v) => {
          props.commonStore.setPage(v);
        });
      }

      if (props.commonStore.mode === 2) {
        props.commonStore.getPage("칼럼", 1).then((v) => {
          props.commonStore.setPage(v);
        });
      }

      if (props.commonStore.mode === 3) {
        props.commonStore.getMyPage(1).then((v) => {
          props.commonStore.setPage(v);
        });
      }
      //선택 시 페이지 저장 초기화 (1로 변경)
      localStorage.setItem("currentPage", 1);
      props.commonStore.setActivePage(1);
    };
    return (
      <Box id="container">
        <div>
          <div className="title">
            <h1>칼럼</h1>
            <LogInfo />
          </div>
          <div className="opt">
            {option.map((v, i) => {
              return (
                <span key={v.id} style={{ color: v.color, borderBottom: `2px solid ${v.border}` }}>
                  <input type="radio" id={v.id} name="menus" value={i} checked={menuRadio[i]} onChange={handleRadio} style={{ display: "none" }} />
                  <label htmlFor={v.id}>
                    {v.name} {lengths[i]}
                  </label>
                </span>
              );
            })}
          </div>
          <ToastMessage />
          <Board lengths={lengths} />
        </div>
      </Box>
    );
  })
);

const Box = styled.div`
  padding: 30px;
  box-sizing: border-box;
  overflow: auto;
  height: 100vh;

  & > div {
    width: 100%;
    height: 100%;

    > .title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      > h1 {
        font-size: 20px;
        font-weight: 700;
      }
    }

    > .opt {
      margin-top: 25px;
      > span {
        box-sizing: border-box;
        padding: 5px 10px;
        margin-right: 10px;

        > label {
          cursor: pointer;
        }
      }
    }
  }
`;

export default MainTemplate;
